// extracted by mini-css-extract-plugin
export default {"productGallery":"rG-z","inQuickShop":"sG-z"};